<form [formGroup]="form" class="flex flex-col gap-6">
  <div class="flex flex-col gap-3">
    <span class="text-sm font-bold text-content-interactive-subdued">{{
      'ANALYSIS.CREATE_CONFIGURATION.HIERARCHY_TITLE' | translate
    }}</span>
    <p class="text-sm text-content-interactive-subdued">
      {{ 'ANALYSIS.CREATE_CONFIGURATION.HIERARCHY_DESCRIPTION' | translate }}
    </p>
  </div>

  <div class="flex flex-col max-h-70 h-70">
    @let groupColumnsHaveVal = this.groupColumns.hasValue();
    @if (this.groupColumns.isLoading()) {
      <div class="flex flex-col flex-1 w-full justify-center items-center">
        <mat-progress-spinner mode="indeterminate" [diameter]="40" />
      </div>
    } @else if (!groupColumnsHaveVal || this.groupColumns.error()) {
      <div class="flex flex-col flex-1 w-full justify-center items-center">
        <pm-loading-failed-hint />
      </div>
    } @else {
      @let groupColumns = this.groupColumns.value() ?? [];
      <pm-drag-and-drop-hierarchy
        [initHierarchy]="this.form.controls.hierarchyOrder.value"
        [initUnassignedGroupColumns]="groupColumns"
        (handleHierarchyChange)="
          this.form.controls.hierarchyOrder.patchValue($event)
        "
      />
    }
  </div>
</form>
